function initFeaturedProductsGrid() {
  var sections = document.querySelectorAll('.js-featured-products-grid:not(.is-initialized)');
  if (!sections.length) return;

  Array.prototype.forEach.call(sections, function (container) {
    container.classList.add('is-initialized');

    var splideEl = container.querySelector('.js-grid-products-splide');
    var productItems = container.querySelectorAll('.featured-products-grid__product-item');
    var prevBtns = container.querySelectorAll('.js-arrow-prev-mobile');
    var nextBtns = container.querySelectorAll('.js-arrow-next-mobile');
    var progressBar = container.querySelector('.js-progress-bar');
    var thumbItems = container.querySelectorAll('.js-thumb-scroll');

    if (!productItems.length) return;

    var slider = null;

    if (splideEl && typeof Splide !== 'undefined') {
      var count = productItems.length;

      var mobileGap = '10px';
      var mobileSlideWidth = 'calc(51.352% - ' + mobileGap + ')';

      slider = new Splide(splideEl, {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '10px',
        pagination: false,
        arrows: false,
        drag: false,
        mediaQuery: 'min',
        breakpoints: {
          992: {
            destroy: true
          },
          0: {
            perPage: 1,
            perMove: 1,
            gap: mobileGap,
            fixedWidth: mobileSlideWidth,
            drag: true,
            arrows: false,
            padding: { left: '16px', right: '16px' }
          }
        }
      });

      function updateSliderControls(index) {
        var visibleSlides = 2;

        if (progressBar && count > 0) {
          var progress = Math.min(100, Math.max(10, ((index + visibleSlides) / count) * 100));
          progressBar.style.width = progress + '%';
        }

        var isFirst = index <= 0;
        var isLast = index >= count - visibleSlides || index >= count - 1;

        Array.prototype.forEach.call(prevBtns, function (btn) {
          if (isFirst) {
            btn.classList.add('is-disabled');
          } else {
            btn.classList.remove('is-disabled');
          }
        });

        Array.prototype.forEach.call(nextBtns, function (btn) {
          if (isLast) {
            btn.classList.add('is-disabled');
          } else {
            btn.classList.remove('is-disabled');
          }
        });
      }

      slider.on('move', function (newIndex) {
        updateSliderControls(newIndex);
      });

      slider.mount();
      updateSliderControls(slider.index || 0);

      Array.prototype.forEach.call(prevBtns, function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (slider && !btn.classList.contains('is-disabled')) {
            slider.go('<');
          }
        });
      });

      Array.prototype.forEach.call(nextBtns, function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (slider && !btn.classList.contains('is-disabled')) {
            slider.go('>');
          }
        });
      });
    }

    Array.prototype.forEach.call(thumbItems, function (thumb) {
      thumb.addEventListener('click', function (e) {
        var href = thumb.getAttribute('href');
        if (href && href.startsWith('#')) {
          var targetEl = document.querySelector(href);
          if (targetEl) {
            e.preventDefault();
            targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initFeaturedProductsGrid);
window.addEventListener('load', initFeaturedProductsGrid);

if ('MutationObserver' in window) {
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (
            node.matches('.js-featured-products-grid') ||
            node.querySelector('.js-featured-products-grid')
          ) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initFeaturedProductsGrid();
            });
            return;
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
